import styled from 'styled-components'

import { AuditLogRecordStyled } from '../../../views/AuditLogRecord/styles/AuditLogRecordStyled'

export const AuditLogListStyled = styled.ul`
  & {
    ${AuditLogRecordStyled} + ${AuditLogRecordStyled} {
      margin-top: ${(props) => props.theme.space.large};
    }
  }
`
